<h2 mat-dialog-title>Password reset email</h2>
<mat-dialog-content>Zwiloo sent instructions to change your password to {{ data.email }}. If you don't see it, check your spam or junk folder.</mat-dialog-content>
<mat-dialog-actions>
  <button type="button" mat-button mat-dialog-close>Okay</button>
</mat-dialog-actions>
